#import "../fragments/products-mutation-fragment.graphql"
#import "../fragments/product-for-lead-fragment.graphql"

mutation AddProductForLead($input: LeadProductAddInput!) {
    leadProductAdd(input: $input) {
        lead {
            ...ProductMutationFragment
        }
        product {
            ...ProductForLeadFragment
        }
    }
}
